<template>

    <div class="blog-newsletter">
        <div class="item">
            <strong>Assine a newsletter</strong> e receba nossa seleção semanal da artigos para manter atualizado
        </div>
        <div class="item">
            <div class="input">
                <input type="email" placeholder="Digite seu e-mail">
                <a class="control">
                    <div>ENVIAR
                    <arrow-horizontal width="20" /></div>
                </a>
            </div>
        </div>
    </div>
</template>

<script>

import ArrowHorizontal from "@/components/Svg/ArrowHorizontal";

export default {

    components : {
        ArrowHorizontal
    }
}
</script>

<style>

</style>
